<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" title=""></PageHeader>

        <b-container class="bg-white p-3 p-md-5 mt-5 mt-sm-2 shadow-sm rounded ">
            <h3 class="text-center mb-5">姓名DNA會員<br>進行登入</h3>

            <b-tabs content-class="mt-3" v-model="tabs" fill>
                <b-tab title="使用帳號密碼登入" active></b-tab>
                <b-tab title="使用LINE登入"></b-tab>
            </b-tabs>
            <div v-if="tabs==1" class="d-flex justify-content-center my-5">

                <b-button   variant="success" class="my-3 mx-5  px-5" size="lg" :disabled="Lineloginloading" @click="linelogin"><b-spinner small v-if="Lineloginloading"></b-spinner> 使用LINE 登入</b-button>

            </div>
            <b-form v-show="tabs==0" style="max-width: 450px" class="mx-auto w-75 ">

                <b-overlay
                        :show="Lineloginloading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="light"
                        class=" mt-3"

                >

                </b-overlay>

                <b-form-group

                        label="手機號碼"
                        description=""
                >
                    <b-form-input

                            v-model="formData.username"
                            maxlength="11"
                            type="text"
                            size="lg"
                            required
                            @change="checkvalue('username')"
                            placeholder="輸入手機號碼"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.usernamecheck">
                        {{ formData.usernamemsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group

                        label="密碼"
                        description=""
                >
                    <b-form-input
                            autocomplete="off"
                            maxlength="20"
                            v-model="formData.password"
                            type="password"
                            size="lg"
                            @change="checkvalue('password')"
                            placeholder="輸入密碼"
                            required
                    ></b-form-input>
                    <b-form-invalid-feedback :state="formData.passwordcehck">
                        {{ formData.passwordmsg }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-checkbox class="mt-3 mb-2 mr-sm-2 mb-sm-0" v-model="formData.longstage">保持登入一段時間</b-form-checkbox>
                <b-alert
                        :show="dismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="dismissCountDown=0"
                        @dismiss-count-down="countDownChanged"
                >
                    {{ alrtmsg }}
                </b-alert>

                <b-overlay
                        :show="loginloading"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=" mt-3"

                >

                <b-button pill variant="primary text-white ActionBtnBg"  block @click="login">登入</b-button>
                </b-overlay>


            </b-form>
            <p v-if="tabs==0" class="mt-3 mt-md-5 text-center">登入遇到問題？
                <b-link href="#foo" to="/RestPW">找回密碼</b-link>
            </p>
            <p class="text-center">尚未擁有帳號？
                <b-button id="show-btn" @click="$bvModal.show('register-model')" size="sm">我要註冊會員</b-button>
            </p>
            <b-modal id="register-model" hide-footer centered>
                <template #modal-title>
                    註冊姓名DNA會員
                </template>
                <div class="d-block text-center">
                    <h4>選擇註冊帳號的方式</h4>
                </div>

                <b-button block variant="primary" class="mb-3" size="lg" to="/Register/default" >使用帳號密碼註冊</b-button>
                <b-button block variant="success" class="mb-3" size="lg" :disabled="Lineloginloading" @click="linelogin"><b-spinner small v-if="Lineloginloading"></b-spinner> 使用LINE進行註冊</b-button>

            </b-modal>

        </b-container>


    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import { toastsModel, toCurrency } from '@/service/commuse'

export default {
  name: 'login',
  components: {Nav,PageHeader},
  data () {
    return {
      formData: {
        username: '',
        usernamecheck: null,
        usernamemsg: '',
        password: '',
        passwordcehck: null,
        passwordmsg: '',
        longstage: true
      },
      loginloading:false,
      Lineloginloading:false,
      dismissCountDown:0,
      alrtmsg:'',
      tabs:0
    }
  },
  computed: {},
  methods: {
    linelogin(){

      this.Lineloginloading = true
      this.$store.dispatch('actionLineAuth', {}).then((res) => {

        window.location.href = res.data;
      })



    },
    checkvalue (way) {
      switch (way) {
        case 'username':
          if (this.formData.username.length == 0 || this.formData.username.length < 10) {
            this.formData.usernamemsg = '請填寫行動電話號碼'
            this.formData.usernamecheck = false

          }

          let isNum = /^\d+$/
          let isPhone = /^09\d{8}$/
          // let isCNPhone = /^1[34578]\d{9}$/
          if (!isNum.test(this.formData.username) ) {
            this.formData.usernamemsg = '請填寫正確行動電話號碼'
            this.formData.usernamecheck = false

          }
          else {
            this.formData.usernamemsg = ''
            this.formData.usernamecheck = true
          }
          break
        case 'password':
          if (this.formData.password.length == 0) {
            this.formData.passwordcehck = false
            this.formData.passwordmsg = '請填寫密碼'

          } else {
            this.formData.passwordcehck = true
            this.formData.passwordmsg = ''
          }
          break
      }

    },
    login () {
      this.checkvalue('username')
      this.checkvalue('password')
      if( this.formData.usernamecheck == true &&
        this.formData.passwordcehck == true ){
        this.loginloading = true
        this.$store.dispatch('actionGetToken', {
          username: this.formData.username,
          password: this.formData.password,
          longstage: this.formData.longstage,
        }).then((res) => {
          this.$store.dispatch('actionGetMemberInfo', {})
            .then((res) => {
              this.$router.push('/home');
              this.loginloading = false
            }).catch((res)=>{
            this.loginloading = false
          })

        }).catch((res) => {

          console.log(res)
          this.alrtmsg = '登入失敗，請檢查帳號及密碼是否正確'
          this.showAlert()

          this.loginloading = false

        })
      }

    },
    countDownChanged(dismissCountDown){
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = 5
    }
  }
}
</script>
